<template>
    <el-dialog
      :visible.sync="dialogVisible"
      :close="handleClose"
      width="305px"
      class="transparent-dialog"
      :show-close="false"
    >
      <div class="dialog-content">
        <img src="https://pstatic.navi-sci.cn/integral/integral-pop.png" class="dialog-img" />
        <div class="exchange-content">
          <div class="exchange-title">提示</div>
          <div class="exchange-icon">
              <img src="https://pstatic.navi-sci.cn/integral/integral-pop_1.png" class="exchange-img" />
          </div>
          <div class="exchange-desc">
              <span>-获得</span>
              <span style="color:#FF1414;">{{item.remark}}</span>
              <span>京东锦鲤商城积分-</span>
          </div>
          <div class="exchange-desc">
              <span>卡密：</span>
              <span style="color:#FF1414;">{{item.exchangeInfo}}</span>
          </div>
          <div class="exchange-btn">
              <el-button type="default" round class="cancel-btn" @click="handleCancel">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </template>
  
  <script>
  export default {
    data() {
      return {
        dialogVisible: false,
        item: {}
      }
    },
    methods: {
      handleClose() {
        // 关闭对话框前的处理
      },
      publicOpen(item) {
          this.item = item
        this.dialogVisible = true
      },
      handleCancel() {
        this.dialogVisible = false
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  .transparent-dialog {
    background-color: transparent;
    box-shadow: none;
  }
  .transparent-dialog ::v-deep .el-dialog{
      background-color: transparent;
      box-shadow: none;
  }
  .transparent-dialog ::v-deep .el-dialog__header,
  .transparent-dialog ::v-deep .el-dialog__body {
    padding: 0;
    background:transparent;
    border-radius: 25px;
    overflow: hidden;
  }
  
  .dialog-content {
    width: 305px;
    height: 330px;
    display: flex;
    .dialog-img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: absolute;
      top: 0;
      left: 0;
    }
    .exchange-content {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: center;
      z-index: 1;
      .exchange-title {
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 13px;
          font-weight: bold;
          color: #832604;
      }
      .exchange-icon {
          width: 110px;
          height: 90px;
          .exchange-img {
              width: 100%;
              height: 100%;
          }
      }
      .exchange-desc{
          font-size: 13px;
          color: #882F0E;
          margin: 10px 20px 0px 20px;
          line-height: 1.5;
      }
      .exchange-btn {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          height: 100px;
          position: absolute;
          bottom: 0px;
          left: 0;
          right: 0;
          width: 100%;
          .cancel-btn {
              width: 30%;
          }
          .confirm-btn {
              background: linear-gradient( 180deg, #FEE49F 0%, #FE3F1B 100%);
              width: 30%;
              border: none;
              margin-left: 20px;
          }
      }
    }
  }
  </style>